import { FC, useState } from "react"
import { Dialog } from 'primereact/dialog';
import './editmodalnumberdialog.css'
import { Button } from "primereact/button";
import { MdEdit, MdOutlineCancel } from "react-icons/md";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { SelectButton } from "primereact/selectbutton";
import { Calendar } from "primereact/calendar";
import { addLocale } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from "primereact/inputnumber";

addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar'
});

export const EditModalNumberDialog:FC<any> = (props):JSX.Element => {

    const { data, setData, dataMASTER, visible, selectedCell, selectedRow, setSelectedRow, handleClose, mode, type, simulated, original,dataPlanificacion } = props 

    
    const handleUpdateDataWarehouse = () => {
        let original = dataMASTER.find((ori:any) => ori.id_warehouse === selectedRow.id_warehouse)?.[selectedCell]
        let aux = data

        let wareohouse_table = aux.map((a:any) => {
            if(a.id_warehouse === selectedRow?.id_warehouse) {
                return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
            }
            return a
        })
        
        setData(wareohouse_table)
        handleClose()
    }

    const renderLabel = () => {
        let field_array = selectedCell?.split("_")
        field_array?.pop()
        
        let header_title = field_array?.map((word:string,index:number) => {
            if(index === 0) {
                return word.charAt(0).toUpperCase() + word.slice(1)
            }
            return word
        }).join(' ')

        return header_title
    }

    const header = () => {
        return (
            <span>Ajuste de parámetros</span>
        )
    }

    const footer = () => {
        return (
            <div className="scenarios-footer">
                <Button severity={'success'} label="Actualizar" disabled={((simulated.scenario_base && !original.scenario_base) && selectedCell === 'stock_inicial_a') || ((simulated.scenario_comparision && !original.scenario_comparision) && selectedCell === 'stock_inicial_b')} icon={<MdEdit style={{fontSize:20}} />}  onClick={handleUpdateDataWarehouse} outlined  />
                <Button severity={'danger'} label="Cancelar" icon={<MdOutlineCancel style={{fontSize:20,marginRight:5}} />}  outlined onClick={handleClose} />
            </div>
        )
    }

    const handleChangeValue = (e:any) => {
        const { value } = e
        setSelectedRow({...selectedRow,[selectedCell]:parseInt(value)})
    }

    const renderTypeDialog = () => {
        switch(type) {
            case 0:
                return (
                    <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem'}}>
                        <div className="card flex justify-content-center" style={{width:'95%'}}>
                            <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>{renderLabel()}</label>
                            <div className="permisos__header-input">
                                <InputNumber inputMode="decimal" minFractionDigits={2} id={"error-name"} style={{width:'100%'}} className="scenario-inputs" onChange={handleChangeValue}  value={selectedRow?.[selectedCell] ?? 0 }    />

                                <span className="p-inputgroup-addon" >
                                    <HiOutlinePencilSquare style={{fontSize:20}} />
                                </span>
                            </div>
                        </div>
                    </div>
                )
            case 1:
                const options = ['Techado', 'No techado'];
                
                const handleFilterType = (e:any) => {
                    if(e.value === 'Techado') {
                        setSelectedRow({...selectedRow,[selectedCell]:true})
                    } else {
                        setSelectedRow({...selectedRow,[selectedCell]:false})
                    }
                   
                }
                return (
                    <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem',flexDirection:'column'}}>
                        <SelectButton value={selectedRow?.[selectedCell] === true? 'Techado' : 'No techado'} onChange={handleFilterType} options={options} />
                    </div>
                )
            case 2:
                const icons = ['Herbáceo', 'Leñoso'];

                const handleFilterIcon = (e:any) => {
                    if(e.value === 'Herbáceo') {
                        setSelectedRow({...selectedRow,[selectedCell]:1})
                    } else {
                        setSelectedRow({...selectedRow,[selectedCell]:2})
                    }
                   
                }
                return (
                    <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem',flexDirection:'column'}}>
                        <SelectButton value={selectedRow?.[selectedCell] === 1? 'Herbáceo' : 'Leñoso'} onChange={handleFilterIcon} options={icons} />
                    </div>
                )
            case 3:

                const meses = [
                    { name: 'Enero', code: 'January' },
                    { name: 'Febrero', code: 'February' },
                    { name: 'Marzo', code: 'March' },
                    { name: 'Abril', code: 'April' },
                    { name: 'Mayo', code: 'May' },
                    { name: 'Junio', code: 'June' },
                    { name: 'Julio', code: 'July' },
                    { name: 'Agosto', code: 'August' },
                    { name: 'Septiembre', code: 'September' },
                    { name: 'Octubre', code: 'October' },
                    { name: 'Noviembre', code: 'November' },
                    { name: 'Diciembre', code: 'December' },
                ];

                const anios:any = [];

                anios.push({name: dataPlanificacion.scenario_base.anio_inicio_planificacion_a.toString()})
                anios.push({name: dataPlanificacion.scenario_base.anio_fin_planificacion_a.toString()})

                const handleChangeYear = (e:any,index:number) => {
                    const { name } = e.value
                    let complete_array = selectedRow?.[selectedCell]
                    let resultado = complete_array.map((ca:any,i:number) => {
                        if(index === i) {
                            return {...ca,anio:parseInt(name)}
                        }
                        return ca 
                    })
                    setSelectedRow({...selectedRow,[selectedCell]:resultado})

                }
                
                const handleChangeMonth = (e:any,index:number) => {
                    const { name } = e.value
                    let complete_array = selectedRow?.[selectedCell]
                    let resultado = complete_array.map((ca:any,i:number) => {
                        if(index === i) {
                            return {...ca,mes:name}
                        }
                        return ca 
                    })
                    setSelectedRow({...selectedRow,[selectedCell]:resultado})

                }

                const handleChangeCantidad = (e:any,index:number) => {
                    const { value } = e
                    let complete_array = selectedRow?.[selectedCell]
                    let resultado = complete_array.map((ca:any,i:number) => {
                        if(index === i) {
                            return {...ca,cantidad:parseFloat(value)}
                        }
                        return ca 
                    })
                    setSelectedRow({...selectedRow,[selectedCell]:resultado})
                }
                

                return (
                    <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem',flexDirection:'column'}}>
                        {
                            selectedRow?.[selectedCell].map((item:any,index:number) => {
                                
                                return (
                                    <div key={index} style={{display:'flex',justifyContent:'space-around',width:'100%',alignItems:'center',marginBottom:'1rem'}}>
                                        <div style={{display:'flex',flexDirection:'column',width:'30%'}}>
                                            <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>Año</label>
                                            <Dropdown  value={item.anio} onChange={(e) => handleChangeYear(e,index)} options={anios} optionLabel="name" editable placeholder="Año" className="w-full md:w-14rem" />
                                        </div>
                                        <div style={{display:'flex',flexDirection:'column',width:'30%'}}>
                                            <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>Mes</label>
                                            <Dropdown  value={item.mes} onChange={(e) => handleChangeMonth(e,index)} options={meses} optionLabel="name" editable placeholder="Mes" className="w-full md:w-14rem" />
                                        </div>
                                        <div className="card flex justify-content-center" style={{width:'30%'}}>
                                            <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>{renderLabel()}</label>
                                            <div className="permisos__header-input">
                                                <InputNumber inputMode="decimal" minFractionDigits={2} id={"error-name"} className="scenario-inputs" onChange={(e) => handleChangeCantidad(e,index)}   value={item.cantidad ?? 0 }    />

                                                <span className="p-inputgroup-addon" >
                                                    <HiOutlinePencilSquare style={{fontSize:20}} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                        
                    </div>
                )
            case 4:

                const handleChangeDate = (e:any) => {
                 
                    setSelectedRow({...selectedRow,[selectedCell]:e.value})
                }
                
                return (
                    <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem'}}>
                        <div className="card flex justify-content-center" style={{width:'95%'}}>
                            <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>{renderLabel()}</label>
                            <Calendar locale="es" style={{width:'100%'}}  dateFormat='dd/mm/yy' value={new Date(selectedRow?.[selectedCell])} onChange={handleChangeDate} showIcon/>
                        </div>
                    </div>
                )
                
        }
    }

    return (
        <div className="card flex justify-content-center">
            <Dialog className={mode === 'base'? "edit-modal-dialog-base" : mode === 'comparision' ? "edit-modal-dialog-compare" : "edit-modal-dialog-neutral"} header={header} visible={visible} style={type === 3? { width: '40vw' }:{ width: '25vw' }} footer={footer} onHide={handleClose}>
                {renderTypeDialog()}
            </Dialog>
        </div>
    )
}